import { React } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

function ReportChart(props) {
  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    CanvasRenderer,
  ]);

  // const labelData=['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

  const yVal = [50, 100, 150, 200, 250, 300, 350];

  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    title: {},
    legend: {
      show: false,
    },
    grid: {
      left: "8%",
      right: "3%",
      bottom: "3%",
      top: 80,
      containLabel: true,
    },
    xAxis: {
      type: "category",
      // name: "Days",
      name: props?.xAxisName,

      nameLocation: "middle",
      nameGap: 35,
      align: "center",
      nameTextStyle: {
        padding: 5,
        fontWeight: "bold",
        color: "#000000",
        //  height:'90px',
        overflow: "none",
      },
      nameGap: 15,
      axisTick: {
        show: false,
      },
      data: props?.dataVal.label,
    },
    yAxis: {
      type: "value",
      //  name: 'Energy\nused\n(kWh)',
      name: props.varName,
      nameLocation: "middle",
      nameGap: 35,
      nameRotate: 1,
      axisLine: {
        show: true,
      },
      nameTextStyle: {
        fontWeight: "bold",
        color: "#000000",
      },
      axisPointer: {
        value: props?.dataVal.label,
      },
      //  data: props?.dataVal[0].LabelVal
    },
    series: [
      {
        type: "bar",
        stack: "total",
        name: "Day",
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        data: props?.dataVal.value,
        showBackground: false,
        itemStyle: {
          color: "#6A9930",
        },
        colorBy: "series",
      },
      // {
      //   type: 'bar',
      //   stack: 'total',
      //   label: {
      //     show: false,
      //   },
      //   itemStyle: {
      //     color: '#99CB4A'
      //   },
      //   emphasis: {
      //     focus: 'series'
      //   },
      //   data:  props?.dataVal[3].faultVal,
      // },
      // {
      //   type: 'bar',
      //   stack: 'total',
      //   label: {
      //     show: false
      //   },
      //   itemStyle: {
      //     color: '#759840'
      //   },
      //   emphasis: {
      //     focus: 'series'
      //   },
      //   data: props?.dataVal[2].swappingVal,
      // }
    ],
  });
  return (
    <ReactECharts
      style={{
        height: "750px",
      }}
      echarts={echarts}
      // notMerge={true}
      // lazyUpdate={true}
      theme={"theme_name"}
      // opts={{renderer: 'svg'}}
      option={options()}
    />
  );
}
export default ReportChart;
